import { LANGUAGE_DE_DE } from '../../../../../i18n';
import { Title } from '../../../../store/api';

export const LANGUAGES = {
    en: 'en',
    de: 'de',
    cy: 'cy'
} as const;

export interface ProductGroupTitle {
    language: keyof typeof LANGUAGES;
    title: string;
}

export const orderTitlesByLocale = (titles: Title[] | undefined, locale: string): ProductGroupTitle[] => {
    if (!titles) {
        return [];
    }
    const en = titles.find(title => title.language === LANGUAGES.en);
    const de = titles.find(title => title.language === LANGUAGES.de);
    const cy = titles.find(title => title.language === LANGUAGES.cy);

    const english = { language: LANGUAGES.en, title: en?.title ?? '' };
    const german = { language: LANGUAGES.de, title: de?.title ?? '' };
    const welsh = { language: LANGUAGES.cy, title: cy?.title ?? '' };

    switch (locale) {
        case LANGUAGE_DE_DE:
            return [german, english, welsh];
        // case 'cy-EN':
        //     return [welsh, english, german];
        default:
            return [english, german, welsh];
    }
};

const parseLocale = (locale: string): keyof typeof LANGUAGES => {
    switch (locale) {
        case LANGUAGE_DE_DE:
            return LANGUAGES.de;
        // case 'cy-EN':
        //     return LANGUAGES.cy;
        default:
            return LANGUAGES.en;
    }
};

export const getLocalisedProductGroupTitle = (titles: Title[] | undefined, locale: string) => {
    const parsedLocale = parseLocale(locale);
    const productGroupTitle = titles?.find(title => title.language === parsedLocale);
    const englishTitle = titles?.find(title => title.language === LANGUAGES.en) ?? {
        title: '',
        language: LANGUAGES.en
    };

    return productGroupTitle ? productGroupTitle.title : englishTitle?.title;
};
